var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-list-tag-container",style:({
    width: _vm.containerWidth + 'px',
    height: _vm.containerHeight + 'px',
  })},[_c('div',{staticClass:"ui-list-tag",style:({
      width: _vm.tagWidth + 'px',
      height: _vm.tagHeight + 'px',
      top: -_vm.tagHeight + 'px',
      transform: 'rotate(' + _vm.rotateX + 'deg)',
      background: _vm.bgColor,
      color: _vm.color,
    })},[_vm._t("default",function(){return [_vm._v("即报即采")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }